import { MAccount } from '../modeles';
import { BaseService } from './base.service';

class AccountService extends BaseService {
  PATH = 'account/';

  async view(): Promise<MAccount | null> {
    return this._view(`${this.PATH}view`);
  }

  async edit(id: number, account: MAccount): Promise<MAccount | null> {
    return this._edit(`${this.PATH}edit/`, account);
  }

  async exportFormat(): Promise<string> {
    return await this._view(`${this.PATH}export-format`) || '';
  }

  async listing(): Promise<MAccount[] | null> {
    return this._listing(`super-admin/${this.PATH}listing`);
  }

  async isActive(id: number, isActive: boolean): Promise<MAccount[]> {
    return this._listing(`super-admin/${this.PATH}is-active/${id}/${isActive}`);
  }

  async isFree(id: number, isFree: boolean): Promise<MAccount[]> {
    return this._listing(`super-admin/${this.PATH}is-free/${id}/${isFree}`);
  }

  async saveDescription(account: MAccount): Promise<MAccount | null> {
    return this._edit(`super-admin/${this.PATH}save-description/`, account);
  }
}

export const accountService = new AccountService();
